<template>
  <b-row>
    <b-col md="7">
      <b-card header-text-variant="white"
              header-bg-variant="dark"
              header-border-variant="dark"
              footer-text-variant="dark"
              footer-bg-variant="dark"
              footer-border-variant="secondary"> 
        
        <div slot="header">
          <strong> Control </strong>
        </div>
        
        <b-row>   
          <b-col md="12">      

            <b-tabs content-class="mt-3">
              <b-tab title="General" active>
                <b-row>
                  <b-col lg="12">
                    <b-form-group label="Descripción" description="Texto debajo del logo">
                      <b-form-input type="text"
                                    size="sm"
                                    v-model="block.control.description"
                                    placeholder="Ingresar un descripción">
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col lg="12">
                    <b-form-group label="HTML" description="Se aplicará en la primer columna debajo de los teléfonos">
                      <prism-editor v-model="block.control.html" language="html" class="content-crud-block-css"></prism-editor>            
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab title="Enlaces">
                <b-row>
                  <b-col>
                    <b-form-group label="Nombre 1">
                      <b-form-input type="text"
                                    size="sm"
                                    v-model="block.control.name1">
                      </b-form-input>                    
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label="Enlace 1">
                      <b-form-input type="url"
                                    size="sm"
                                    v-model="block.control.link1">
                      </b-form-input>  
                    </b-form-group>                    
                  </b-col>
                </b-row>

                <b-row>
                  <b-col>
                    <b-form-group label="Nombre 2">
                      <b-form-input type="text"
                                    size="sm"
                                    v-model="block.control.name2">
                      </b-form-input>                    
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label="Enlace 2">
                      <b-form-input type="url"
                                    size="sm"
                                    v-model="block.control.link2">
                      </b-form-input>  
                    </b-form-group>                    
                  </b-col>
                </b-row>

                <b-row>
                  <b-col>
                    <b-form-group label="Nombre 3">
                      <b-form-input type="text"
                                    size="sm"
                                    v-model="block.control.name3">
                      </b-form-input>                    
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label="Enlace 3">
                      <b-form-input type="url"
                                    size="sm"
                                    v-model="block.control.link3">
                      </b-form-input>  
                    </b-form-group>                    
                  </b-col>
                </b-row>  

                <b-row>
                  <b-col>
                    <b-form-group label="Nombre 4">
                      <b-form-input type="text"
                                    size="sm"
                                    v-model="block.control.name4">
                      </b-form-input>                    
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label="Enlace 4">
                      <b-form-input type="url"
                                    size="sm"
                                    v-model="block.control.link4">
                      </b-form-input>  
                    </b-form-group>                    
                  </b-col>
                </b-row>       

                <b-row>
                  <b-col>
                    <b-form-group label="Nombre 5">
                      <b-form-input type="text"
                                    size="sm"
                                    v-model="block.control.name5">
                      </b-form-input>                    
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label="Enlace 5">
                      <b-form-input type="url"
                                    size="sm"
                                    v-model="block.control.link5">
                      </b-form-input>  
                    </b-form-group>                    
                  </b-col>
                </b-row>     

                <b-row>
                  <b-col>
                    <b-form-group label="Nombre 6">
                      <b-form-input type="text"
                                    size="sm"
                                    v-model="block.control.name6">
                      </b-form-input>                    
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label="Enlace 6">
                      <b-form-input type="url"
                                    size="sm"
                                    v-model="block.control.link6">
                      </b-form-input>  
                    </b-form-group>                    
                  </b-col>
                </b-row> 
              </b-tab>
              <b-tab title="Resumen para el comprador">
                <div>
                  <b-card no-body>
                    <b-tabs pills card vertical>
                      <b-tab title="Bloque 1" active>
                        <b-card-text>
                          <b-form-group label="Icono 1" description="Puede cargar iconos desde https://fontawesome.com/icons?d=gallery&m=free">
                            <b-form-input type="text"
                                          size="sm"
                                          v-model="block.control.icon1">
                            </b-form-input>                    
                          </b-form-group>
                          <b-form-group label="Titulo 1">
                            <b-form-input type="text"
                                          size="sm"
                                          v-model="block.control.title1">
                            </b-form-input>                    
                          </b-form-group>
                          <b-form-group label="Subtitulo 1">
                            <b-form-input type="text"
                                          size="sm"
                                          v-model="block.control.subtitle1">
                            </b-form-input>                    
                          </b-form-group>                                                    
                        </b-card-text>
                      </b-tab>
                      <b-tab title="Bloque 2">
                        <b-card-text>
                          <b-form-group label="Icono 2" description="Puede cargar iconos desde https://fontawesome.com/icons?d=gallery&m=free">
                            <b-form-input type="text"
                                          size="sm"
                                          v-model="block.control.icon2">
                            </b-form-input>                    
                          </b-form-group>
                          <b-form-group label="Titulo 2">
                            <b-form-input type="text"
                                          size="sm"
                                          v-model="block.control.title2">
                            </b-form-input>                    
                          </b-form-group>
                          <b-form-group label="Subtitulo 2">
                            <b-form-input type="text"
                                          size="sm"
                                          v-model="block.control.subtitle2">
                            </b-form-input>                    
                          </b-form-group>                                
                        </b-card-text>
                      </b-tab>
                      <b-tab title="Bloque 3">
                        <b-card-text>
                          <b-form-group label="Icono 3" description="Puede cargar iconos desde https://fontawesome.com/icons?d=gallery&m=free">
                            <b-form-input type="text"
                                          size="sm"
                                          v-model="block.control.icon3">
                            </b-form-input>                    
                          </b-form-group>
                          <b-form-group label="Titulo 3">
                            <b-form-input type="text"
                                          size="sm"
                                          v-model="block.control.title3">
                            </b-form-input>                    
                          </b-form-group>
                          <b-form-group label="Subtitulo 3">
                            <b-form-input type="text"
                                          size="sm"
                                          v-model="block.control.subtitle3">
                            </b-form-input>                    
                          </b-form-group>     
                        </b-card-text>
                      </b-tab>
                    </b-tabs>
                  </b-card>
                </div>
              </b-tab>     
              <b-tab title="Firma Diseñador">
                <b-row>
                  <b-col>
                    <b-form-group label="Empresa">
                      <b-form-input type="text"
                                    size="sm"
                                    v-model="block.control.designBussinesName">
                      </b-form-input>                    
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label="Sitio Web">
                      <b-form-input type="url"
                                    size="sm"
                                    v-model="block.control.designBussinesSite">
                      </b-form-input>  
                    </b-form-group>                  
                  </b-col>
                </b-row>
              </b-tab>
            </b-tabs>

          </b-col>          
        </b-row>
      </b-card>
    </b-col>
    <b-col md="5">
      <b-card header-text-variant="white"
              header-bg-variant="dark"
              header-border-variant="dark"
              footer-text-variant="dark"
              footer-bg-variant="dark"
              footer-border-variant="secondary"> 

        <div slot="header">
          <strong> Configuración </strong>
        </div>

        <b-row>
          <b-col md="12">
            <b-form-group label="Color de Fondo ">
              <b-form-input v-model="block.config.backgroundColor" type="color"></b-form-input>
            </b-form-group>
          </b-col>      
          <b-col md="12">      
            <b-form-group label="Imagen de Fondo" description="Imagen 1: se utiliza para desktop | Imagen 2: se uliza para mobile (si no esta cargada se usa la imagen 1)">                          
              <Imagen :images="block.config.backgroundImage" 
                      @load-image="block.config.backgroundImage = $event" 
                      typeImage="BackgroundImage"
                      :multipleImage="true"
                      :maxImage="2" 
                      :compressImage="true"/>
            </b-form-group> 
          </b-col>  
         
          <b-col md="12">
            <b-form-group label="Estilos" description="Las clases CSS ingresadas se aplicarán solo a este bloque">
              <prism-editor v-model="block.config.stylesCSS" language="css" class="content-crud-block-css"></prism-editor>            
            </b-form-group>
          </b-col>           

        </b-row>
      </b-card>
    </b-col>
  </b-row>  
</template>
<script>  
  import Imagen from '@/components/inc/image/image'
  import PrismEditor from 'vue-prism-editor'
  import "prismjs";
  import "prismjs/themes/prism.css";

  export default { 
    components: {     
      PrismEditor,    
      Imagen,
    },       
    props: {
      dataBlock:{
        type: Object,
        default: {}
      },      
    },    
    data: () => {
      return {   
        block: {},               
        render: false,        
      }
    },   
    created() {               
      if(!this.dataBlock.control) {
        this.block.control = { 
          description: '',
          html: '',
          name1: '',
          name2: '',
          name3: '',
          name4: '',
          name5: '',
          name6: '',
          link1: '',
          link2: '',
          link3: '',
          link4: '',
          link5: '',
          link6: '',
          icon1: 'flaticon-shipped',
          icon2: 'flaticon-money-back',
          icon3: 'flaticon-support',
          title1: 'Entrega gratis',
          title2: 'Garantía devolución de 30 días',
          title3: '24/7 Soporte en línea',
          subtitle1: '',
          subtitle2: '',
          subtitle3: '',
          designBussinesName: '',
          designBussinesSite: '',
        },
        this.block.config = {
          backgroundColor: '#f7f8fb',
          backgroundImage: [],
          stylesCSS: '',
        }
        this.block.images = [],
        this.block.imagesConfig = ['backgroundImage'],

        this.emit()
        this.render = true
      }
      else {         
        this.block.control= { 
          description: this.dataBlock.control.description,
          html: this.dataBlock.control.html,
          name1: this.dataBlock.control.name1,
          name2: this.dataBlock.control.name2,
          name3: this.dataBlock.control.name3,
          name4: this.dataBlock.control.name4,
          name5: this.dataBlock.control.name5,
          name6: this.dataBlock.control.name6,
          link1: this.dataBlock.control.link1,
          link2: this.dataBlock.control.link2,
          link3: this.dataBlock.control.link3,
          link4: this.dataBlock.control.link4,
          link5: this.dataBlock.control.link5,          
          link6: this.dataBlock.control.link6,          
          icon1: this.dataBlock.control.icon1,
          icon2: this.dataBlock.control.icon2,
          icon3: this.dataBlock.control.icon3,
          title1: this.dataBlock.control.title1,
          title2: this.dataBlock.control.title2,
          title3: this.dataBlock.control.title3,
          subtitle1: this.dataBlock.control.subtitle1,
          subtitle2: this.dataBlock.control.subtitle2,
          subtitle3: this.dataBlock.control.subtitle3,
          designBussinesName: this.dataBlock.control.designBussinesName,
          designBussinesSite: this.dataBlock.control.designBussinesSite
        }                             
        
        var imgConfg = []  
        var i = 0         
        var backgroundImage = 2
        if(backgroundImage) {          
          for (i; i < backgroundImage; i++) {                        
            if(this.dataBlock.config["backgroundImage_" + i]) {
              imgConfg.push({ path: this.dataBlock.config["backgroundImage_" + i] })
            }   
          }          
        }        

        this.block.config= { 
          backgroundColor: this.dataBlock.config.backgroundColor,                                       
          backgroundImage: imgConfg,
          stylesCSS: this.dataBlock.config.stylesCSS,
        }

        this.block.images = []
        this.block.imagesConfig = ['backgroundImage']

        this.emit()
        this.render = true
      }
    },
    methods: {
      emit() {        
        this.$emit('get-object', this.block) 
      },
    }        
  }
</script>